import { DefaultOptions, QueryClient } from '@tanstack/react-query';

const globalQueryOptions: DefaultOptions['queries'] = {
  cacheTime: 0,
  enabled: false,
  refetchOnWindowFocus: false,
  retry: 0,
  staleTime: Infinity,
};

export const queryClientFactory = (
  queryOptions: DefaultOptions['queries'] = globalQueryOptions
) => {
  return new QueryClient({
    defaultOptions: {
      queries: queryOptions,
    },
  });
};
